/* eslint-disable import/no-cycle */
import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';
import { useModalContext } from '../../core/context/ModalContext';
import { Icon } from '../common/Icons';
import { StyledModalContainer, StyledCloseButton } from './Modal.styles';

function Modal({ children, id, showCloseButton }) {
  const { isOpen, getControl } = useModalContext();
  const { close } = getControl(id);

  const CloseButton = useCallback(() => {
    if (!showCloseButton) return null;

    return (
      <StyledCloseButton type="button" onClick={close}>
        <Icon.Close />
      </StyledCloseButton>
    );
  }, [showCloseButton, close]);

  if (!isOpen(id)) return null;

  return ReactDOM.createPortal(
    <StyledModalContainer>
      <CloseButton />
      {children}
    </StyledModalContainer>,
    document.getElementById('portal-root')
  );
}

export default Modal;
